import type { StaffPrivacyRequestView } from "@lafayette/schemas";

import type { PrivacyCapabilities } from "./access";

// Which buttons a request card offers to this staff member. Presentation only: the API decides every command again (a role without the
// capability gets a 403, a stale screen a 409). Kept apart from the page so the rules are one small pure function with its own test.

export type RequestActions = Readonly<{
  /** Approve or reject: only while the request waits for a decision. */
  decide: boolean;
  /** Withdraw: only while nobody has started the request. */
  cancel: boolean;
  /** Run again: only for a request that is partly done. */
  retry: boolean;
  /** Download the export file: only an export that staff asked for, completed, with a file that is still there. */
  download: boolean;
}>;

export function requestActionsFor(
  request: StaffPrivacyRequestView,
  capabilities: PrivacyCapabilities,
): RequestActions {
  return {
    decide: capabilities.approve && request.state === "REQUESTED",
    cancel: capabilities.request && (request.state === "REQUESTED" || request.state === "APPROVED"),
    retry: capabilities.approve && request.state === "PARTIALLY_COMPLETED",
    download:
      capabilities.downloadExport &&
      request.kind === "EXPORT" &&
      request.state === "COMPLETED" &&
      request.requesterKind === "staff" &&
      request.export?.available === true,
  };
}
